class DataTableManager {
  getSortTableColumns(columns, oldColumns = null, except = []) {
    Object.entries(columns).forEach((column) => {
      if (!except.includes(column[0])) {
        column[1]["sortable"] = true;
        column[1]["sortWay"] =
          oldColumns && oldColumns[column[0]] && oldColumns[column[0]].sortWay ? oldColumns[column[0]].sortWay : "";
      }
    });
    return columns;
  }
  setRowActionParams(action, row) {
    let params = {};
    action.actionParams.forEach((param) => {
      if (param.data) {
        params[param.title] = param.data;
      } else {
        const element = row.find((element) => element.name === param.code);
        params[param.title] = element?.data?.value;
      }
    });
    return params;
  }

  isRowActionVisible(action, row) {
    if (!action?.conditions || Object.keys(action.conditions).length === 0) {
      return true;
    }

    const shouldHide = Object.entries(action.conditions).some(([key, value]) => {
      const conditionItem = row.find((element) => element.name === key);
      let shouldHide = false;
      value.forEach((item) => {
        if (conditionItem?.data?.value === item) {
          shouldHide = true;
        }
      });
      return shouldHide;
    });

    return !shouldHide;
  }

  findId(row) {
    return row.find((element) => element.name === "id").data.value;
  }

  getListParams(search = "", limit = 10, sortOrder = "ASC", sortByField = null, keywords = "", offset = 0) {
    return {
      search: search,
      sortByField: sortByField,
      sortOrder: sortOrder,
      limit: limit,
      offset: offset,
      keywords: keywords,
    };
  }

  getParamsFormSessionStorage(storageItem) {
    let params = "";
    const stored = JSON.parse(storageItem);
    const query = new URLSearchParams(stored).toString();
    params = "search=" + query;
    return params;
  }

  processRows(sliceLimit, rowList, limit, offset) {
    if (rowList && rowList.length) {
      sliceLimit = offset + parseInt(limit);
      let rows = {};
      if (Object.keys(rowList).length) {
        const sliced = Object.entries(rowList).slice(offset, sliceLimit);

        sliced.forEach((row) => {
          rows[row[0]] = row[1];
          rows[row[0]] = row[1];
        });
      }
      return rows;
    }
  }
  sort(column, columnName, currentSortType, apiFilters = true) {
    if (!column.sortable) {
      return { shouldRefreshList: false, initSort: false };
    }

    const sortType = currentSortType === "DESC" ? "ASC" : "DESC";
    const sortWay = sortType === "ASC" ? "up" : "down";

    return {
      sortColumn: columnName,
      sortType,
      sortWay,
      shouldRefreshList: apiFilters,
      initSort: true,
    };
  }

  resetSort(columns) {
    Object.values(columns).forEach((column) => {
      if (column.sortable) {
        column.sortWay = "";
      }
    });
  }
}

export const dataTableManager = new DataTableManager();
